import React from 'react';

interface ResearchMenuIconProps {
  className?: string;
  size?: number;
}

const ResearchMenuIcon: React.FC<ResearchMenuIconProps> = ({ className = '', size = 20 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.3875 10.4108L3.2375 11.5092C3.0376 11.5525 2.82866 11.5155 2.65587 11.406C2.48308 11.2965 2.36033 11.1234 2.31417 10.9242L1.86667 9.13249C1.81406 8.91662 1.84393 8.68889 1.95045 8.4939C2.05696 8.29891 2.23244 8.15071 2.4425 8.07833L13.6958 4.37833"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.3 9.78916L14.91 9.01917L11.3 9.78916Z" fill="currentColor" />
      <path
        d="M11.3 9.78916L14.91 9.01917"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 17.5L10.7458 12.325"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7375 4.95C13.6304 4.52124 13.6979 4.06748 13.9253 3.68852C14.1527 3.30956 14.5213 3.03642 14.95 2.92917L15.8583 2.7025C16.0726 2.64905 16.2993 2.68283 16.4887 2.79643C16.6781 2.91002 16.8146 3.09414 16.8683 3.30833L18.1308 8.35833C18.1845 8.57272 18.1509 8.79965 18.0373 8.98922C17.9236 9.17878 17.7394 9.31545 17.525 9.36917L16.6167 9.59583C16.1879 9.70296 15.7341 9.6354 15.3552 9.40802C14.9762 9.18065 14.7031 8.81207 14.5958 8.38333L13.7375 4.95Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.13167 7.19417L6.06 10.9075"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66666 17.5L9.25416 12.325"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5C10.9205 12.5 11.6667 11.7538 11.6667 10.8333C11.6667 9.91286 10.9205 9.16667 10 9.16667C9.07953 9.16667 8.33334 9.91286 8.33334 10.8333C8.33334 11.7538 9.07953 12.5 10 12.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ResearchMenuIcon;
